import ListingDetail from "@realtorSitesClient/pages/ListingDetail";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/listing/$listingId/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ListingDetail />;
}
